(ns app.front.view.case-note.section
  (:require [app.front.view.case-note.list :as case-note-list]
            [app.front.view.case-note.subs :as cn-subs]
            [app.front.view.workspace.section :as ws-section]
            [core.front.carbon :as cc]
            [core.front.event :refer [<sub >evt]]
            [core.front.icons :as i]))

(defn- add-note-button []
  (let [tr    (<sub [::cn-subs/tr])
        title (tr [:case-note/add])]
    (cc/button
      {:kind             :ghost
       :icon             i/plus
       :icon-description title
       :on-click         #(>evt [::cn-subs/begin-creating-note])}
      title)))

(defn section
  [{:keys [phase state]}]
  (let [phase-id (:db/id phase)]
    [ws-section/section
     phase
     :case-notes-section
     ;; TODO: Clicking a button in the header does NOT expand the section if it was closed!
     (cond-> state
       (<sub [::cn-subs/can-add? phase-id])
       (assoc :heading-button [add-note-button]))
     :view/case-notes
     true
     ^{:key "case-notes"}
     [case-note-list/view phase-id]]))
